// extracted by mini-css-extract-plugin
module.exports = {"error":"Tournaments_error__17qng"};